import type {
  Facilities,
  StudioFacilities,
} from '@bond/bruce-api/common/facility'

export function checkFacilityAdded(
  oldFacilities: StudioFacilities,
  newFacilities: Facilities,
) {
  const addedFacilities: Facilities = []

  newFacilities.forEach((newFacility) => {
    const oldFacility = oldFacilities.find(
      (oldFacility) => oldFacility.facility_id === newFacility.id,
    )

    if (!oldFacility) {
      addedFacilities.push(newFacility)
    }
  })

  return addedFacilities
}

export function checkFacilityRemoved(
  oldFacilities: StudioFacilities,
  newFacilities: Facilities,
) {
  const deletedFacilities: StudioFacilities = []

  oldFacilities.forEach((oldFacility) => {
    const newFacility = newFacilities.find(
      (newFacility) => newFacility.id === oldFacility.facility_id,
    )

    if (!newFacility) {
      deletedFacilities.push(oldFacility)
    }
  })

  return deletedFacilities
}
